import { createContext, useContext } from 'react';
import { ActorRefFrom } from 'xstate';
import { licensesFormMachine } from '../licenseForm.machine';

type LicensesActorRef = ActorRefFrom<typeof licensesFormMachine>;

export const LicensesRefContext = createContext<LicensesActorRef | null>(null);

export function useLicensesActorRef() {
  const ref = useContext(LicensesRefContext);
  if (!ref)
    throw new Error('useLicenseActorRef must be used within the AccountActorRefContext.Provider');
  return ref;
}
